import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache) {
  const _component_cookies_h1 = _resolveComponent("cookies-h1")
  const _component_cookies_p = _resolveComponent("cookies-p")
  const _component_puzzle_component = _resolveComponent("puzzle-component")
  const _component_cookies_button = _resolveComponent("cookies-button")
  const _component_cookies_panel = _resolveComponent("cookies-panel")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_cookies_panel, null, {
      default: _withCtx(() => [
        _createVNode(_component_cookies_h1, null, {
          default: _withCtx(() => [
            _createTextVNode(" Reliade ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_cookies_p, null, {
          default: _withCtx(() => [
            _createTextVNode(" Raccordez tout les blocs blancs aux blocs noirs de même couleur. ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_puzzle_component),
        (_ctx.win)
          ? (_openBlock(), _createElementBlock("div", { key: 0 }, [
              _createVNode(_component_cookies_p, { style: {"text-align":"center"} }, {
                default: _withCtx(() => [
                  _createTextVNode(" 🎉 C'est gagné pour aujourd'hui ! 🥳 "),
                  _createElementVNode("br"),
                  _createVNode(_component_cookies_button, {
                    onClick: $event => (_ctx.share()),
                    title: "Copier dans le presse-papier",
                    confetti: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Partager ")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}